export const pmgInvestListHeaderOptions = [
  { title: "S No." },
  { title: "Name" },
  { title: "Designation" },
  { title: "Active" },
  { title: "Action" }
];

export const pmgUpdatesListHeaders = [
  { title: "S No." },
  { title: "Title" },
  { title: "Release Date" },
  { title: "Active" },
  { title: "Action" }
];
